const localeToBcp47: Record<string, string> = {
  en: "en-US",
  it: "it-IT",
};

export function formatDateWithLocale(
  value: Date | string | undefined,
  locale: string,
  kind: "date" | "dateTime" = "date"
): string {
  if (value == null) return "-";
  try {
    const date = typeof value === "string" ? new Date(value) : value;
    if (Number.isNaN(date.getTime())) return "-";

    const bcp47 = localeToBcp47[locale] || locale;
    if (kind === "dateTime") {
      return date.toLocaleString(bcp47, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    return date.toLocaleDateString(bcp47, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "-";
  }
}

export const formatDate = (
  date: Date | string | undefined,
  locale = "it"
): string => {
  return formatDateWithLocale(date, locale, "date");
};

